import React from 'react';

function initialsFromName(name) {
  return String(name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || '')
    .join('') || 'PK';
}

export default function ProductThumb({ product, size = 'md', className = '' }) {
  const imageUrl = String(product?.image_url || '').trim();
  const label = product?.name || 'Product';
  const initials = initialsFromName(label);

  if (imageUrl) {
    return (
      <div className={`product-thumb product-thumb-${size} ${className}`.trim()}>
        <img src={imageUrl} alt={label} className="product-thumb-image" loading="lazy" />
      </div>
    );
  }

  return (
    <div className={`product-thumb product-thumb-${size} product-thumb-fallback ${className}`.trim()} aria-label={label}>
      <span>{initials}</span>
    </div>
  );
}
